import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Html5Qrcode, Html5QrcodeCameraScanConfig, Html5QrcodeScannerState } from "html5-qrcode";

@Component({
  selector: 'app-html5-qrcode-reader',
  templateUrl: './html5-qrcode-reader.component.html',
  styleUrls: ['./html5-qrcode-reader.component.scss'],
})
export class Html5QrcodeComponent implements OnInit {

  private scanner?: Html5Qrcode = undefined;
  private config: Html5QrcodeCameraScanConfig = { fps: 10, aspectRatio: 4/3};
  private cameraContId: string = "html5-qrcode";

  @Output() onCameraScanValue = new EventEmitter<QrScanResult>();
  @Output() onCameraInit = new EventEmitter<boolean>();

  onCameraScan(decodedText, decodedResult){
    this.onCameraScanValue.emit({'decodedText': decodedText, 'decodedResult': decodedResult});
  }

  ngOnDestroy(){
    console.log("ngOnDestroy");

    if(this.scanner){
      let state: Html5QrcodeScannerState = this.scanner.getState();
      if(state == Html5QrcodeScannerState.SCANNING)
      {
        this.scanner.stop();
      }
    }
  }

  ngOnInit(): void {
    if(this.scanner === undefined)
      this.scanner = new Html5Qrcode(this.cameraContId);
    
    this.scanner.start({ facingMode: "user" }, this.config, (a, b) => {this.onCameraScan(a, b);}, undefined)
      .then((res) => {this.onCameraInit.emit()});
  }
}

export interface QrScanResult{
  decodedText: string,
  decodedResult:any
}